import { CSSProperties } from 'react';
import { Button } from '@react-email/components';
import { ButtonSection, Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useComposerSection } from '../../content-composer/hooks/use-composer-section';
import type { ComposerSectionOutputProps, Corners } from '../../content-composer/types';
import { SectionFrame } from '../atoms/section-frame';
import { useLinks } from '../hooks/use-links';
import { getCornersStyle } from '../utils/get-corners-style';

export const ButtonOutput = ({ renderMode }: ComposerSectionOutputProps) => {
  const { props } = useComposerSection<ButtonSection>();
  const href = useCreateButtonLink(props.link, renderMode);

  return (
    <SectionFrame {...props.frame}>
      <Button style={getButtonStyle(props)} href={href}>
        {props.link?.text ?? ''}
      </Button>
    </SectionFrame>
  );
};

const getButtonStyle = (props: ButtonSection): CSSProperties => ({
  ...getCornersStyle(props.corners as Corners | undefined),
  background: props.buttonColor,
  color: props.textColor,
  border: '0',
  fontSize: '16px',
  lineHeight: '18px',
  cursor: 'pointer',
  padding: '10px 20px',
});

const useCreateButtonLink = (link?: Link, renderMode?: string) => {
  const { createFormLink, formatLink, getAddressLink, getCallToActionLink, getOnlineScheduleLink } = useLinks();

  switch (link?.linkType) {
    case 'phone':
    case 'email':
      return formatLink(link?.url ?? '', link?.linkType, renderMode);
    case 'custom':
      return formatLink(link.url ?? '');
    case 'form':
      return createFormLink(link, renderMode);
    case 'address':
      return getAddressLink(renderMode);
    case 'schedule':
      return getOnlineScheduleLink(renderMode);
    case 'confirmation':
      return getCallToActionLink(renderMode);
    default: {
      return '';
    }
  }
};
